import { Component, Vue } from "vue-property-decorator";

import { SideNav } from "@/layout";
import { ConfirmDelete, Lightbox } from "@/components";
import { ErrorCode, ErrorMessage } from "@/constant";
import { ClassModel } from "@/models";
import { Common } from "../Common";

export class SearchForm {
    keyword = '';
    type = '';
    sid = '';
    cid = '';
    active = '';
}

type response = { [key: string]: unknown };

@Component<AdminClassIndexController>({
    components: {
        SideNav, ConfirmDelete, Lightbox
    }
})
export default class AdminClassIndexController extends Vue {
    private doubleClick = false;
    private searchForm = new SearchForm();
    private cityList: { [key: string]: any} = {};
    private schoolList: { [key: string]: any} = {};
    private classList: object = {};
    private num = 0;
    private pageHtml = "";
    private clid = 0;
    private identity = window.localStorage.getItem('admin_identity') as string;
    private cid = '';
    private sid = window.localStorage.getItem('admin_sid') as string;
    private token = window.localStorage.getItem('adminToken') as string;

    private errorMsg = "";
    private openLB = false;
    private errNo!: number;

    public async created() {
        if (this.identity == "1") {
            this.cityList = await Common.getSchoolCity(); //取得有分校之縣市
        } else {
            this.cityList = await Common.getCity(this.sid); //取得該分校之縣市
            this.cid = this.cityList[0].cid;
            this.searchForm.cid = this.cid;

            const school = window.localStorage.getItem('admin_school') as string;
            this.schoolList[0] = {
                sid: this.sid,
                name: school,
            };
            this.searchForm.sid = this.sid;
        }
        this.getClassList();
    }

    //取得該縣市之分校
    private async getSchool(cid: string) {
        if (this.identity == "1") { //權限為分校者，不連動下拉列表
            this.searchForm.sid = '';
            this.schoolList = await Common.getSchool(cid);
        }
    }

    private async getClassList() {
        if (this.identity == '2') {
            this.searchForm.cid = this.cid;
            this.searchForm.sid = this.sid;
        }
        const item: { [key: string]: string } = {
            page: this.$route.query.page as string,
            keyword: this.searchForm.keyword,
            type: this.searchForm.type,
            sid: this.searchForm.sid,
            cid: this.searchForm.cid,
            active: this.searchForm.active,
            token: this.token,
        }
        const data = await ClassModel.getList(item) as response;
        Common.checkToken(data.ERR_CODE as number);
        this.num = data.num as number;
        this.classList = data.list as object;
        this.pageHtml = data.pageHtml as string;
    }

    private delClass(id: number) {
        this.$emit("openConfirmDelete", true);
        this.clid = id;
    }

    private async deleteClass() {
        if (!this.doubleClick) {
            this.doubleClick = true;

            const item: { clid: number, token: string } = {
                clid: this.clid,
                token: this.token,
            }
            this.errNo = await ClassModel.del(item);
            this.$emit("closeConfirmDelete", false);
            Common.checkToken(this.errNo);
            this.openLB = true;
            this.doubleClick = false;
            this.errorMsg = ErrorMessage[this.errNo];
        }
    }

    private closeLB() {
        this.openLB = false;
        if (this.errNo === ErrorCode.Success) {
            this.$router.go(0);
        }
    }
}
